import React from 'react';
import T from 'prop-types';
import { Button } from 'antd';

const UpdateSubscriptionButton = ({ isUserStandard, isUserAdvanced, push, showUpdateSubscriptionModal }) => {
  if (isUserStandard) {
    return (
      <Button onClick={() => push({ pathname: '/pricing' })} type="primary">
        Upgrade
      </Button>
    );
  }

  if (isUserAdvanced) {
    return (
      <>
        <Button onClick={showUpdateSubscriptionModal} type="primary">
          Upgrade
        </Button>
      </>
    );
  }

  return null;
};

UpdateSubscriptionButton.propTypes = {
  push: T.func.isRequired,
  showUpdateSubscriptionModal: T.func.isRequired,

  isUserStandard: T.bool.isRequired,
  isUserAdvanced: T.bool.isRequired,
};

export default UpdateSubscriptionButton;
